import { Component, OnInit } from '@angular/core';
import { DatePipe } from '@angular/common';
import { FormGroup, UntypedFormBuilder, Validators } from '@angular/forms';
import { ComponentBase } from '../../../../core/_infrastructure/classes/componentBase';
import { EnumIdsTcPais, Tc } from '../../../../core/_infrastructure/types/common';
import { TInterValoHoraPuntoInspeccionViewModel } from '../../../../_mantenimiento/general/puntosinspeccion/puntoinspeccion.types';
import { PeriodoCamService } from '../../../../_mantenimiento/campanias/periodos/datosbasicos/periodocam.service';
import { InspeccionesExService } from '../inspeccionesEx.service';
import { ReasignacionPcfViewModel } from '../inspeccionesEx.types';
import { ActivatedRoute, Router } from '@angular/router';
import { GlobalService } from '../../../../core/_infrastructure/classes/services/global.service';
import { PuntoInspeccionService } from '../../../../_mantenimiento/general/puntosinspeccion/puntoinspeccion.service';
import { AuthService } from '../../../../core/_infrastructure/classes/services/auth.service';
import { NotificationService } from '../../../../core/_infrastructure/classes/services/notification.service';
import { ExceptionManager } from '../../../../core/_infrastructure/classes/handlers/exceptionManager';
import { NavMenuService } from '../../../../core/components/navmenu/navmenu.service';
import { HttpParams } from '@angular/common/http';

@Component({
    selector: 'app-reasignacionpcf-wrapper',
    templateUrl: './reasignacionpcf-wrapper.component.html',
})
export class ReasignacionPcfWrapperComponent extends ComponentBase implements OnInit {
    //Inputs
    listPuntoInspeccion: Tc[] = [];
    listHoras: TInterValoHoraPuntoInspeccionViewModel[] = [];
    listUbicacion: Tc[] = [];
    listInstalacionAutorizada: Tc[] = [];

    IdSolicitudEx: number | null = null;
    HoraReasignacion: string | null = null;
    IdProvincia: number | null = null;
    validacionCollection: string[] = [];
    IdPuntoInspeccion: number | null = null;
    ultimaReasignacion: ReasignacionPcfViewModel;
    esGrabador = false;

    constructor(
        public datepipe: DatePipe,
        private router: Router,
        private fb: UntypedFormBuilder,
        private globalService: GlobalService,
        private puntoInspeccionService: PuntoInspeccionService,
        protected authService: AuthService,
        protected notificacionService: NotificationService,
        protected exceptionHandler: ExceptionManager,
        private activatedRoute: ActivatedRoute,
        private inspeccionesExService: InspeccionesExService,
        private navMenuService: NavMenuService,
    ) {
        super(authService, notificacionService, exceptionHandler);
    }

    ngOnInit(): void {
        this.createForm();

        this.IdSolicitudEx = +this.activatedRoute.snapshot.params['id'];

        if (this.IdSolicitudEx) {
            const params = new HttpParams()
                .set('idpais', EnumIdsTcPais.ID_ESPANA.toString())
                .set('esgrabador', this.esGrabador.toString())
                .set('idusuario', this.loggedInUser!.Id.toString());

            this.globalService.getPuntoInspeccionNuevaSolicitudExportacion(params).subscribe(res => {
                this.listPuntoInspeccion = res;
            });

            this.inspeccionesExService.getUltimaReasignacionPcf(this.IdSolicitudEx).subscribe(res => {
                this.ultimaReasignacion = res;
            });
        }
    }

    createForm() {
        this.form = this.fb.group({
            IdPuntoInspeccion: [null, Validators.required],
            IdUbicacion: [null, Validators.required],
            IdInstalacionAutorizada: [null, Validators.required],
            IdIntervaloHoras: [null],
        });
    }

    obtenerDatosPorPuntoInspeccion(idPuntoInspeccion: number) {
        if (!idPuntoInspeccion) {
            this.listUbicacion = [];
            this.listInstalacionAutorizada = [];
            this.listHoras = [];
            return;
        }

        this.obtenerUbicaciones(idPuntoInspeccion);
        this.obtenerIntervalosHora(idPuntoInspeccion);

        this.puntoInspeccionService.getPuntoInspeccion(idPuntoInspeccion).subscribe(result => {
            this.IdProvincia = result.IdProvincia;
            this.obtenerInstalacionesAutorizadas(this.IdProvincia!);
        });
    }

    obtenerUbicaciones(idPuntoInspeccion: number) {
        const params = new HttpParams().set('id', idPuntoInspeccion.toString()).set('esexportacion', 'true');

        this.globalService.getUbicacionByPuntoInspeccion(params).subscribe(res => {
            this.listUbicacion = res;
        });
    }

    obtenerInstalacionesAutorizadas(idProvincia: number) {
        this.globalService.getInstalacionesAutorizadasByProvincia(idProvincia).subscribe(res => {
            this.listInstalacionAutorizada = res;
        });
    }

    obtenerIntervalosHora(idPuntoInspeccion: number) {
        this.inspeccionesExService.getIntervalosHora(idPuntoInspeccion).subscribe(res => {
            this.listHoras = res;
        });
    }

    onSubmit() {
        /*let reasignacionPcf = this.form.getRawValue() as ReasignacionPcfViewModel;*/

        let reasignacionPcf: ReasignacionPcfViewModel = {
            IdPuntoInspeccion: this.form.controls['IdPuntoInspeccion'].value,
            IdUbicacion: this.form.controls['IdUbicacion'].value,
            IdInstalacionAutorizada: this.form.controls['IdInstalacionAutorizada'].value,
            IdIntervaloHoras: this.form.controls['IdIntervaloHoras']?.value,
            IdSolicitudEx: +this.activatedRoute.snapshot.params['id'],
        };

        if (reasignacionPcf.IdPuntoInspeccion === this.ultimaReasignacion.IdPuntoInspeccion) {
            this.addErrorMessage('No se puede reasignar un mismo punto de inspección');
            return;
        }

        this.inspeccionesExService.crearReasignacionPcf(reasignacionPcf).subscribe({
            next: res => {
                this.navMenuService.resetSolicitudExData();
                this.navMenuService.refresh();
                this.addSuccessMessage('Solicitud modificada correctamente');
                this.router.navigate(['/exportacion/solicitudes']);
            },
            error: error => {
                this.catchServerError(error);
            },
        });
    }

    onBack() {
        this.router.navigate(['/exportacion/solicitudes']);
    }

    get formInvalid(): boolean {
        return !this.form.valid || !this.form.dirty || this.form.pristine;
    }
}
